export class ComplexBuildingCategoryModel {
  data: BuildingCategoryModel[];
  total: number;
}

export class BuildingCategoryModel {
  id: string;
  name: string;
}
